<script>
import {computed} from "vue";
import {formatDateTime} from "@/tools/date-time.tools";
import {openImagePreview} from "@/composables/image-preview";

export default {
  name: "ClubNewsCard",
  props: ['newsItem'],
  setup(props) {
    const newsTime = computed(() => {
      return formatDateTime(props.newsItem.created_at);
    })
    return {newsTime, openImagePreview}
  }
}
</script>

<template>
  <div class="clubNewsCard">
     <div class="clubNewsCard__header">
       <img class="clubNewsCard__headerImage" alt="" :src="require('@/assets/img/club-news/card-icon.png')">
       <div class="clubNewsCard__headerContent">
          <span>{{newsItem.author}}</span>
          <span>{{newsTime}}</span>
       </div>
     </div>
     <img class="clubNewsCard__image" alt="" :src="newsItem.img_url" @click="openImagePreview(newsItem.img_url)">
     <div class="clubNewsCard__text">{{ newsItem.body }}
     </div>
  </div>
</template>

<style scoped lang="scss">
.clubNewsCard {
  border-radius: var(--cd-card-border-radius);
  background-color: var(--cd-card-bg);
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 10px;
  &__header {
    display: flex;
    gap: 10px;
    span {
      display: block;
    }
  }
  &__text {
    white-space: pre-wrap;
  }
  &__image {
    max-width: 100%;
    height: auto;
    cursor: zoom-in;
  }
}
</style>
